<template>
  <Header/>
  <Wrapper/>
  <Footer/>
</template>

<script>
import Header from './Header.vue'
import Wrapper from './Wrapper.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Wrapper,
    Footer
  }
}
</script>

<style>
/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>
